// @ts-check
import _ from 'lodash';
import Text from 'components/base/Text';
import { SPACES } from 'common/constants/sizes';
import { Separator } from 'components/Separators';
import { HyperLink } from 'components/base/HyperLink';
import { Flex } from 'components/base/layout-components';
import { LBButton } from '@linearb/buzz';

export const getLicenseBarText = license => {
  return license.isTrial ? (
    <Flex items='baseline' data-testid='trialText'>
      <Separator color='waikawaGray' pl={SPACES.small} />
      <Text color='white' size='small'>
        {_.get(license, 'daysLeftOnTrial')} days left on your trial
      </Text>
    </Flex>
  ) : (
    <div data-testid='paidText' />
  );
};

export const getLicenseBarButton = (license, openPremiumRequest = () => {}) => {
  return license.isTrial ? (
    <Flex items='baseline' data-testid='trialButton'>
      <HyperLink
        href={`https://linearb.io/pricing/`}
        color='white'
        size='small'
        mr={SPACES.small}
        target='_blank'
      >
        Learn about our plans
      </HyperLink>
      <LBButton variant='outline' size='lg' onClick={openPremiumRequest}>
        Upgrade
      </LBButton>
    </Flex>
  ) : (
    <div data-testid='paidButton' />
  );
};
